import moment from "moment";

// Filtros compartidos entre los tabs de reportes (Resultados, Ventas, Gastos).
// Cualquier filtro que tenga que aplicarse de forma transversal entre los tabs
// vive acá. Hoy: el mes de referencia del calendario y el rango de período.

const state = {
    endMonth: moment().toDate(),
    selectedPeriodRange: "lastYear",
};

const mutations = {
    SET_END_MONTH(state, date) {
        state.endMonth = date;
    },
    SET_SELECTED_PERIOD_RANGE(state, range) {
        state.selectedPeriodRange = range;
    },
};

const actions = {
    /**
     * Cambia el rango de período. Si el rango implica una fecha-fin canónica
     * distinta del endMonth actual (ej. previousYear → 31-Dic del año pasado),
     * también actualiza endMonth para que el calendario y la consulta queden
     * coherentes entre sí.
     */
    setPeriodRange({ commit }, range) {
        commit("SET_SELECTED_PERIOD_RANGE", range);

        if (range === "previousYear") {
            const previousYearEnd = moment().subtract(1, "year").endOf("year").toDate();
            commit("SET_END_MONTH", previousYearEnd);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
